module.exports = __webpack_public_path__ + "img/mika-on-unelma-alasi.bbf0d75c.jpg";